import qs from "qs";
import axios from "axios";

const url = process.env.VUE_APP_API_BASE_URL;

function list(params) {
    let options = {
        params: params,
        paramsSerializer: function(params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            Accept: "application/vnd.api+json",
            "Content-Type": "application/vnd.api+json"
        }
    }

    return axios.get(
        `${url}/admin/form-types`,
        options
    ).then((response) => ({ list: response.data.data }));
}

function get(id) {
    const options = {
        headers: {
            Accept: "application/vnd.api+json",
            "Content-Type": "application/vnd.api+json"
        }
    };

    return axios.get(`${url}/admin/form-types/${id}`, options).then(response => {
        return response.data.data;
    });
}

function add(payload) {
    const options = {
        headers: {
            Accept: "application/vnd.api+json",
            "Content-Type": "application/vnd.api+json"
        }
    };

    return axios.post(`${url}/admin/form-types`, payload, options).then(response => {
        return response.data;
    });
}

function update(payload) {
    const options = {
        headers: {
            Accept: "application/vnd.api+json",
            "Content-Type": "application/vnd.api+json"
        }
    };

    return axios
        .put(`${url}/admin/form-types/${payload.id}`, payload, options)
        .then(response => {
            return response.data;
        });
}

function destroy(payload) {
    const options = {
        headers: {
            Accept: "application/vnd.api+json",
            "Content-Type": "application/vnd.api+json"
        }
    };

    return axios.delete(`${url}/admin/form-types/${payload.id}`, options);
}

export default {
    list,
    get,
    add,
    update,
    destroy
};